module.exports = __webpack_public_path__ + "static/media/msg.94df8c92.svg";